import { combineReducers } from '@reduxjs/toolkit';
import { reducer as listReducer } from './list';
import { reducer as tagsReducer } from './tags';

export default combineReducers({
  list: listReducer,
  tags: tagsReducer,
});
